module.exports = __webpack_public_path__ + "static/media/apple.9ea01a21.svg";